import React from 'react';
import { ClusterPageTemplate } from '../components/ClusterPageTemplate';
export function ClusterVastgoedbeheerPage() {
  return <ClusterPageTemplate clusterName="Vastgoedbeheer" sectorName="Makelaars & Vastgoed" sectorSlug="makelaars-vastgoed" heroTitle="Website laten maken voor vastgoedbeheerders" heroDescription="Professionele websites voor vastgoedbeheerders en verhuurders. Wij bouwen platforms die huurders informeren en jouw beheerproces stroomlijnen." websiteOnderdelen={[{
    icon: 'HomeIcon',
    title: 'Huuraanbod',
    description: 'Een overzichtelijk aanbod van beschikbare huurwoningen of bedrijfspanden met duidelijke specificaties.'
  }, {
    icon: 'WrenchIcon',
    title: 'Reparatieverzoeken',
    description: 'Een digitaal formulier waar huurders eenvoudig en gestructureerd reparatieverzoeken kunnen indienen.'
  }, {
    icon: 'FileTextIcon',
    title: 'Informatie voor huurders',
    description: 'Een kennisbank of FAQ-sectie met antwoorden op veelgestelde vragen over huur, contracten en onderhoud.'
  }, {
    icon: 'BriefcaseIcon',
    title: 'Diensten voor beleggers',
    description: 'Informatie over financieel, technisch en commercieel beheer voor vastgoedbeleggers.'
  }]} functionaliteiten={[{
    icon: 'FileTextIcon',
    title: 'Storingsformulier',
    description: "Een slim formulier waarbij huurders direct foto's van het defect kunnen uploaden."
  }, {
    icon: 'UsersIcon',
    title: 'Huurdersportaal',
    description: 'Mogelijkheid tot integratie met een beveiligde omgeving waar huurders hun contracten en facturen kunnen inzien.'
  }, {
    icon: 'SearchIcon',
    title: 'Vindbaarheid',
    description: 'SEO-optimalisatie om gevonden te worden door nieuwe vastgoedbeleggers die beheer uit handen willen geven.'
  }]} siblingClusters={[{
    name: 'Makelaar',
    slug: 'makelaar'
  }, {
    name: 'Projectontwikkelaar',
    slug: 'projectontwikkelaar'
  }, {
    name: 'Woningpresentatie',
    slug: 'woningpresentatie'
  }]} faqs={[{
    q: 'Kan ik een systeem voor reparatieverzoeken inbouwen?',
    a: "Ja, we kunnen uitgebreide formulieren bouwen waarmee huurders direct de juiste informatie en foto's aanleveren, wat jouw administratie scheelt."
  }, {
    q: 'Koppelen jullie ook met beheersoftware?',
    a: 'We kunnen de website koppelen aan bekende vastgoedbeheer softwarepakketten, zodat aanbod en meldingen direct in jullie systeem binnenkomen.'
  }, {
    q: 'Wat kost een website voor vastgoedbeheer?',
    a: 'Een professionele website start vanaf €1.500. Afhankelijk van koppelingen met beheersoftware of een huurdersportaal maken we een offerte op maat.'
  }, {
    q: 'Is de website makkelijk zelf te beheren?',
    a: 'Ja, via het WordPress CMS kun je zelf eenvoudig nieuw huuraanbod plaatsen, teksten aanpassen of nieuwsberichten publiceren.'
  }]} data-id="element-1094" />;
}